// @flow
import React from 'react';

type Props = {
  onClick: () => void,
  className: string,
};

const CustomNextArrow = (props: Props) => (
  <div role="button" tabIndex={0} className={props.className} onClick={props.onClick} />
);

export default CustomNextArrow;
